/**
 * Rewrite a Shopify CDN image URL to fetch a smaller version.
 *   .../files/foo.jpg?v=123 → .../files/foo_512x.jpg?v=123
 * Significantly lowers bandwidth + GPU memory on mobile. No-op for
 * non-Shopify URLs or already-sized paths.
 */
import { isTouchDevice } from "../util/device.js";

export function resizeShopifyImage(url: string, width: number): string {
  if (url === "" || !url.includes("cdn.shopify.com")) {
    return url;
  }
  if (/_\d+x\d*\./.test(url)) {
    return url;
  }
  // Touch devices get half-size product images: with ~40 stores of tiles and
  // holograms the image downloads dominate mobile load time, and a phone
  // screen can't show the extra pixels anyway.
  const effective: number = isTouchDevice() ? Math.max(128, Math.floor(width / 2)) : width;
  return url.replace(/(\.\w{2,4})(\?.*)?$/, `_${effective}x$1$2`);
}
